var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emergency-plan-demo"},[_c('h2',{staticClass:"plan-title"},[_vm._v(_vm._s(_vm.planTitle))]),(_vm.isTyphoonRedPlan)?_c('TyphoonRedEmergencyPlan'):(_vm.isPropertyInitialFirePlan)?_c('PropertyInitialFireEmergencyPlan'):[_c('p',{staticClass:"plan-status"},[_vm._v("正在建设中")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }